import { makeContextModule } from '@cian/react-utils';

import { type IApplicationContext } from '../../types/applicationContext';

const {
  Context: { Provider: ApplicationContextProvider },
  useContext: useApplicationContext,
} = makeContextModule<IApplicationContext>({
  contextName: 'ApplicationContext',
});

export { ApplicationContextProvider, useApplicationContext };
